import {
  LEGALPERMISSION_LOADING,
  GET_LEGALPERMISSION,
  GET_LEGALPERMISSION_SUCCESS,
  GET_LEGALPERMISSION_FAIL,
  ADD_LEGALPERMISSION_SUCCESS,
  ADD_LEGALPERMISSION_FAIL,
  DELETE_LEGALPERMISSION_SUCCESS,
  DELETE_LEGALPERMISSION_FAIL,
  UPDATE_LEGALPERMISSION_SUCCESS,
  UPDATE_LEGALPERMISSION_FAIL,
  LEGALPERMISSION_RESET
} from "./actionType";

const INIT_STATE = {
  legalPermissions: [],
  error: {},
};

const LegalPermission = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LEGALPERMISSION_SUCCESS:
      switch (action.payload.actionType) {
        case GET_LEGALPERMISSION:
          return {
            ...state,
            legalPermissions: action.payload.data,
            isLegalPermissionCreated: false,
            isLegalPermissionSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_LEGALPERMISSION_FAIL:
      switch (action.payload.actionType) {
        case GET_LEGALPERMISSION_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isLegalPermissionCreated: false,
            isLegalPermissionSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_LEGALPERMISSION: {
      return {
        ...state,
        isLegalPermissionCreated: false,
        loading: true,
      };
    }

    case LEGALPERMISSION_LOADING: {
      return {
        ...state,
        isLegalPermissionCreated: false,
        loading: true,
      };
    }

    case ADD_LEGALPERMISSION_SUCCESS:
      return {
        ...state,
        isLegalPermissionCreated: true,
        loading: false,
        legalPermissions: [action.payload.data, ...state.legalPermissions],
      };

    case ADD_LEGALPERMISSION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_LEGALPERMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        legalPermissions: state.legalPermissions.filter(
          legalPermission => legalPermission.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_LEGALPERMISSION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_LEGALPERMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        legalPermissions: state.legalPermissions.map(legalPermission =>
          legalPermission.id.toString() === action.payload.data.id.toString() ? { ...legalPermission, ...action.payload.data } : legalPermission
        ),
      };

    case UPDATE_LEGALPERMISSION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LEGALPERMISSION_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default LegalPermission;